import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { FirebaseService } from '../firebase/firebase.service';

export const authGuard: CanActivateFn = () => {
  const firebaseService = inject(FirebaseService);
  const router = inject(Router);

  return combineLatest([
    firebaseService.authStateChecked$,
    firebaseService.user$,
  ]).pipe(
    filter(([checked]) => checked),
    take(1),
    map(([, user]) => {
      if (!user) {
        void router.navigate(['/onboarding-select']);
        return false;
      }
      return true;
    }),
  );
};
